import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type { PostPdfsRequestType, PostPdfsResponseType } from '../types';

export const postPdfs = async (params: PostPdfsRequestType) => {
  const url = `/api/v2/pdfs`;
  const { data } = await apiAuthClient.post<PostPdfsResponseType>(url, params);
  return data;
};
